var moduleMap = {
	"./View": function() {
		return Promise.all([__webpack_require__.e(421), __webpack_require__.e(879), __webpack_require__.e(824), __webpack_require__.e(651), __webpack_require__.e(343), __webpack_require__.e(61), __webpack_require__.e(49), __webpack_require__.e(970)]).then(function() { return function() { return (__webpack_require__(4452)); }; });
	},
	"./ViewContainer": function() {
		return Promise.all([__webpack_require__.e(421), __webpack_require__.e(879), __webpack_require__.e(824), __webpack_require__.e(651), __webpack_require__.e(343), __webpack_require__.e(61), __webpack_require__.e(49), __webpack_require__.e(639)]).then(function() { return function() { return (__webpack_require__(68049)); }; });
	},
	"./ViewTypeEnum": function() {
		return __webpack_require__.e(140).then(function() { return function() { return (__webpack_require__(90140)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});